<template class="lad-peger">
  <nuxt-link
    v-if="isPagerWithLink"
    :key="`page-type-${type}-${currentPage}-${internalPageCount}`"
    :to="link"
    ><span class="left-right"><i :class="`fas fa-angle-${label}`" /></span>
  </nuxt-link>
  <span v-else class="left-right not-allowed"
    ><i :class="`fas fa-angle-${label}`"
  /></span>
</template>

<script>
export default {
  name: 'LadPeger',
  props: {
    prevBefore: { type: String, default: 'sizes' },
    nextBefore: { type: String, default: 'pager' },
    pageParamName: { type: String, default: 'page' },
  },
  data() {
    return {
      position: null,
    }
  },
  computed: {
    paginatorItems() {
      return this.$parent.$children.map((child) => child._uid)
    },
    index() {
      return this.paginatorItems.findIndex((uid) => uid === this._uid)
    },
    type() {
      const list = this.$parent.layout.split(',').map((t) => t.trim())

      return list[this.index - 1]
    },
    currentPage() {
      return this.$parent.currentPage
    },
    internalPageCount() {
      return this.$parent.internalPageCount
    },
    label() {
      return this.isPrev ? 'left' : 'right'
    },
    isPrev() {
      return this.type === this.prevBefore
    },
    isNext() {
      return this.type === this.nextBefore
    },
    isPagerWithLink() {
      return (
        (this.isPrev && this.currentPage > 1) ||
        (this.isNext && this.currentPage < this.internalPageCount)
      )
    },
    link() {
      const route = {
        name: this.$route.name,
        params: { ...this.$route.params },
        query: { ...this.$route.query },
      }

      if (this.isPrev && this.currentPage > 1) {
        route.query[this.pageParamName] = this.currentPage - 1
      } else if (this.isNext && this.currentPage < this.internalPageCount) {
        route.query[this.pageParamName] = this.currentPage + 1
      }

      return route
    },
  },
}
</script>
